import React, { useState, useEffect } from 'react';
import { Container, Typography, Paper, Box, Grid, CircularProgress } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const [stats, setStats] = useState({
    vehicleCount: 0,
    driverCount: 0,
    routeCount: 0
  });
  const [loading, setLoading] = useState(true);
  const { getAuthHeaders } = useAuth();

  useEffect(() => {
    const loadStats = async () => {
      try {
        setLoading(true);
        
        // Autentikáció nélkül kérjük le az adatokat
        const [vehiclesRes, driversRes, routesRes] = await Promise.all([
          axios.get('/api/Vehicles/count'),
          axios.get('/api/Drivers/count'),
          axios.get('/api/Routes/count')
        ]);

        console.log('API válaszok:', {
          vehicles: vehiclesRes.data,
          drivers: driversRes.data,
          routes: routesRes.data
        });

        setStats({
          vehicleCount: vehiclesRes.data,
          driverCount: driversRes.data,
          routeCount: routesRes.data
        });
      } catch (error) {
        console.error('Hiba a statisztikák betöltésekor:', error);
      } finally {
        setLoading(false);
      }
    };

    loadStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Üdvözöljük a T-Busz Adatbázis rendszerben!
      </Typography>
      <Typography variant="body1" paragraph>
        Ez a rendszer lehetővé teszi a buszok, sofőrök és vonalak adatainak kezelését.
      </Typography>
      <Typography variant="body1" paragraph>
        A bal oldali menü segítségével navigálhat a különböző funkciók között.
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          Rendszerstatisztika
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="h6">Járművek</Typography>
                <Typography variant="h4">{stats.vehicleCount}</Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="h6">Sofőrök</Typography>
                <Typography variant="h4">{stats.driverCount}</Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="h6">Vonalak</Typography>
                <Typography variant="h4">{stats.routeCount}</Typography>
              </Paper>
            </Grid>
          </Grid>
        )}
      </Box>
    </Container>
  );
};

export default Dashboard;
